module.exports = __webpack_public_path__ + "static/media/aap.32b78239.png";